/** Standard primary CTA for /amazon-fba-prep-services conversion tracking. */
export const FBA_PREP_PRIMARY_CTA = 'Get a Free Custom Quote';

export const FBA_PREP_CONTACT_PATH = '/contact-fulfillment-services';
